module.exports = __webpack_public_path__ + "img/1.0dafe9d6.png";